<template>
  <div class="basket-icon">
    <router-link class="h-icon" :to="{name: 'cart'}">
      <cart-icon title="Koszyk" />
      <span class="badge">{{cartPositions}}</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CartIcon from "vue-material-design-icons/Cart.vue";

export default {
  components: {
    CartIcon
  },
  computed: {
    ...mapState({
      basket: state => state.basket.basket
    })
  },
  data() {
    return {
      cartPositions: 0
    };
  },
  watch: {
    basket: {
      handler: function(value) {
        this.cartPositions =
          value.baskets.length > 0
            ? value.baskets.map(b => b.positions.length).reduce((a, b) => a + b)
            : 0;
      },
      deep: true
    }
  },
  beforeMount() {
    this.$store.dispatch("basket/data");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/button/BasketIcon.vue